import React, { useEffect } from 'react';
import { Box, Button, CopyClipboard, Divider, Text, TextButton } from '@wix/design-system';
import getSymbolFromCurrency from 'currency-symbol-map';
import style from './PaymentLinkWidget.scss';
const SHARE_LINK_MESSAGE = 'share latest pay link';
export const PaymentLinkWidget = _ref => {
  let {
    data: {
      paymentLinkId,
      title,
      description,
      currency,
      price,
      expirationDate,
      paymentsLimit,
      link
    },
    context: {
      onWidgetAction,
      send
    }
  } = _ref;
  const getCurrencySymbol = currencyCode => getSymbolFromCurrency(currencyCode) || currencyCode;
  const formatDate = date => {
    return new Intl.DateTimeFormat('en', {
      month: 'long',
      day: 'numeric'
    }).format(date);
  };
  useEffect(() => {
    onWidgetAction == null || onWidgetAction(PAYMENT_LINK_WIDGET, {
      action: 'show',
      value: paymentLinkId
    });
  }, []);
  const isLongPrice = (price == null ? void 0 : price.toString().length) > 5;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "175px",
    direction: "vertical",
    gap: 3
  }, /*#__PURE__*/React.createElement(Box, {
    borderRadius: "8px",
    border: "1px solid #DFE5EB",
    width: "175px",
    minHeight: "190px",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "#ECEFF3",
    width: "100%",
    borderRadius: "8px 8px 0 0",
    overflow: "hidden",
    align: "center",
    verticalAlign: "middle",
    padding: "24px 0",
    height: "60px"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "90%",
    align: "center",
    marginTop: "12px"
  }, /*#__PURE__*/React.createElement(Text, {
    className: isLongPrice ? style.priceCurrencySmall : style.priceCurrency
  }, getCurrencySymbol(currency)), /*#__PURE__*/React.createElement(Text, {
    ellipsis: true,
    className: isLongPrice ? style.priceAmountSmall : style.priceAmount
  }, price))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    alignContent: "center",
    margin: "SP3 SP4",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    textAlign: "center",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "normal",
    size: "small",
    maxLines: 2,
    ellipsis: true
  }, title)), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    maxLines: 3,
    ellipsis: true
  }, description)), expirationDate && /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "normal",
    size: "tiny"
  }, "Expires: ", formatDate(new Date(expirationDate)))), paymentsLimit && /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "normal",
    size: "tiny",
    ellipsis: true
  }, "Payments limit: ", paymentsLimit)))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 2,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(CopyClipboard, {
    value: link ?? ''
  }, _ref2 => {
    let {
      isCopied,
      copyToClipboard,
      reset
    } = _ref2;
    return /*#__PURE__*/React.createElement(Button, {
      size: "tiny",
      skin: "ai",
      onClick: () => {
        onWidgetAction == null || onWidgetAction(PAYMENT_LINK_WIDGET, {
          action: 'copy',
          value: link
        });
        return isCopied ? reset() : copyToClipboard();
      }
    }, "Copy Link");
  }), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: () => {
      onWidgetAction == null || onWidgetAction(PAYMENT_LINK_WIDGET, {
        action: 'share',
        value: link
      });
      send(SHARE_LINK_MESSAGE);
    }
  }, "Share"))));
};
export const PAYMENT_LINK_WIDGET = 'PAYMENT_LINK_WIDGET';

/** type ToolExecuteResponse.WidgetSpec (Assistant tool that respond with widget) example:
 *
 * widget: {
    widget: 'PAYMENT_LINK_WIDGET',
    data: {
      title: 'Payment Link',
      description: 'This is a payment link',
      price: 100,
      currency: 'USD',
      link: 'http://example.com'
    }
  }
*/
//# sourceMappingURL=PaymentLinkWidget.js.map